import React, { useState, useEffect, useRef } from "react";
import DragAndDropFileUpload from "./DragAndDropFileUpload";

const Attachments = ({UploadedFiles, childAttachmentClearFunc}) => {

    /*state declarations */
    //const [loading, setLoading] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadedFilesRows, setUploadedFilesRows] = useState([]);

     /*ref declaration*/
     const ClearAttachmentError = useRef(null);

    useEffect(() => {
        childAttachmentClearFunc.current = ClearAttachmentsAfterSave;
    }, [])

    const ClearAttachmentsAfterSave = () => {
        setUploadedFiles([]);
        setUploadedFilesRows([]);
        ClearAttachmentError.current();
    }

    const onDelete = (fileName) => {
        let FilesRowAfterDelete = uploadedFilesRows.filter(el => el.filename !== fileName);
        let FilesAfterDelete = uploadedFiles.filter(el => el.name !== fileName);
        setUploadedFiles(FilesAfterDelete);
        UploadedFiles(FilesAfterDelete);
        setUploadedFilesRows(FilesRowAfterDelete);
    }

    const onUpload = (filesList, callback, fileDesc) => {
        //setLoading(true);
        setTimeout(() => {
            //setLoading(false);
            callback && callback(true);
            setFilesList(filesList);
            SetFiles(filesList);
        }, 1000);
    };

    const SetFiles = (fileslst) => {
        const files = [...uploadedFiles];
        fileslst.forEach((file) => (
            files.push(file)
        ));
        setUploadedFiles(files);
        UploadedFiles(files);
    }

    const setFilesList = (fileDetails) => {
        const files = [...uploadedFilesRows];
        let newlyAddedFiles = fileDetails.map((file) => {
            return {
                filename: file.name,
                filesize: bytesToSize(file.size),
                date: formatDate(new Date()),
            };
        });
        setUploadedFilesRows([...files, ...newlyAddedFiles]);
    };

    const formatDate = (date) => {
        //const formattedDate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
        const formattedDate = new Date(date).toDateString();
        return formattedDate;
    };

    const bytesToSize = (bytes) => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes === 0) return "0 Byte";
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    };

    return(
        <DragAndDropFileUpload
            acceptFileTypes={["doc", "docx", "jpg", "jpeg", "png", "pdf"]}
            maxFileSize="10000000" //10 MB
            hintText="Attachments cannot be greater than 10MB. Acceptable formats: DOC, DOCX, JPG, JPEG, PNG or PDF"
            onUpload={onUpload}
            uploadedFilesRows={uploadedFilesRows}
            onDelete={onDelete}
            ClearAttachmentError={ClearAttachmentError}
        />
    )
}

export default Attachments;